export default __webpack_public_path__ + "static/media/HANDER.8a16205e.png";